import React, { useState, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from "../config/config";

const UploadProducts = () => {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null); // for resetting input

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!file) {
      toast.error("Please select a file before submitting.");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      setIsLoading(true);
  
      const response = await axios.post(`${api_url}/bulk/upload`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      });
  

  
      const message = response.data?.message || "Products uploaded successfully ! ";
  
      if ([200, 201].includes(response.status) || response.data?.success) {
        toast.success(message);
        setFile(null); // Clear file from state
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clear input field
        }
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.error("Upload error:", error);
      const errorMessage =
        error.response?.data?.message || "An error occurred while uploading the file.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  
  

  const handleDownloadSample = () => {
    const link = document.createElement("a");
    link.href = "/bulk_upload_products.xlsx";
    link.download = "bulk_upload_products.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex flex-col items-center p-6 border py-20 rounded-md shadow-md max-w-md mx-auto">
      <ToastContainer />
      <h1 className="text-2xl font-semibold mb-4">Upload Products</h1>
      <form onSubmit={handleSubmit} className="flex flex-col items-center space-y-4 w-full">
      <input
  type="file"
  accept=".xls,.xlsx"
  onChange={handleFileChange}
  ref={fileInputRef}
  className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
/>
        <button
          type="submit"
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 disabled:bg-gray-400 w-full"
          disabled={isLoading}
        >
          {isLoading ? "Uploading..." : "Upload"}
        </button>

        <div className="flex justify-between gap-4 w-full">
          <button
            type="button"
            onClick={handleDownloadSample}
            className="bg-green-600 text-white py-2 px-1 rounded hover:bg-green-700 w-full"
          >
            Download Sample File
          </button>

          <Link to={`/ng-admin/product-list`} className="w-full">
            <button
              type="button"
              className="w-full bg-purple-800 text-white py-2 px-4 rounded hover:bg-purple-600"
            >
              Back to Products
            </button>
          </Link>
        </div>
      </form>
    </div>
  );
};

export default UploadProducts;
